'use strict';

angular.module('far.admin')
.controller('MountainsEditController', function($scope, $log, $timeout, $window, form, mountains, mountainRegions) {
	var vm = {
		progress: true,
		mountainModel: form('mountainModel'),
		submit: submit,
		getMountain: getMountain,
		alerts: [],
		closeAlert: function(index) {
			vm.alerts.splice(index, 1);
		}
	};

	var mountainPeakModel = form('mountainPeak');
	mountainPeakModel
		.addField('name', null, {
			options: {
				placeholder: 'Название'
			},
			label: 'Название вершины:'
		})
		.addField('description', 'textarea', {
			label: 'Описание:'
		})
		.addField('mountain_area', 'mountainAreaSelect', {
			validators: {
				required: true
			},
			fieldData: {
				labelRegion: 'Регион',
				labelArea: 'Район'
			}
		}, mountainRegions.list)
		.addField('height', 'number', {
			validators: {
				required: false
			},
			options: {
				placeholder: 'Высота'
			},
			label: 'Высота вершины:'
		})
		.addField('longitude', null, {
			validators: {
				required: false
			},
			options: {
				placeholder: 'Долгота'
			},
			label: 'Долгота:'
		})
		.addField('latitude', null, {
			validators: {
				required: false
			},
			options: {
				placeholder: 'Широта'
			},
			label: 'Широта:'
		});

	vm.mountainModel
		.addField('name', null, {
			validators: {
				required: true
			},
			options: {
				placeholder: 'Название'
			},
			label: 'Название горы:'
		})
		.addField('description', 'textarea', {
			label: 'Описание:'
		})
		.addField('mountainPeaks', 'collection', {
			validators: {
				required: true
			},
			label: 'Вершины горы:',
			buttons: {
				add: 'Добавить новую вершину',
				remove: 'Удалить'
			},
			fieldData: {
				doDelete: function(item) {
					item.deleted_at = new Date();
				},
				ngRepeat: 'item in model|filter:field.filterArray track by $index',
				filterArray: function(item) {
					return !item.deleted_at;
				}
			}
		}, mountainPeakModel);

	function getMountain(mountainId) {
		if (angular.isUndefined(mountainId)) {
			vm.mountain = mountains.new({});
			vm.progress = false;
		} else {
			vm.mountain = mountains.get(mountainId, function() {
				vm.progress = false;
			});
		}
	}

	// TODO: Success сообщения для всей админки
	function submit() {
		$log.debug(vm.mountain);

		vm.mountain.save()
			.then(function() {
				$window.location.href = Routing.generate('admin_mountains');
			})
			.catch(function(response) {
				$log.error(response);
				vm.alerts.push({
					type: 'danger',
					message: 'Не удалось сохранить изменения на сервере. Попробуйте повторить попытку через некоторое время.'
				});
			});
	}

	return vm;
});